export default "__VITE_ASSET__MrGsoKSF__"